<template>
  <div class="video-wrap">
    <div class="form-wrap">
      <h1>{{$t('adminVideo.title')}}</h1>
      <hr />
      <div class="upload-wrap">
        <div class="video-for">
          <h2>
            {{$t('adminVideo.videoFor')}}
            <span class="material-icons" style="font-size: 40px;">arrow_right_alt</span>
          </h2>
          <select v-model="selectedLocation">
            <option
              v-for="(eachData, index) in data"
              :key="index"
              :value="eachData"
            >{{eachData.name}}</option>
          </select>
        </div>
        <div class="types">
          <h2>
            {{$t('adminVideo.type')}}
            <span class="material-icons">arrow_right_alt</span>
          </h2>
          <div class="mp4-wrap">
            <input type="radio" id="intro" name="type" value="intro" v-model="type" />
            <label for="intro">Intro</label>
          </div>
          <div class="ogg-wrap">
            <input type="radio" id="loop" name="type" value="loop" v-model="type" />
            <label for="loop">Loop</label>
          </div>
        </div>
        <div class="extension">
          <h2>
            {{$t('adminVideo.extension')}}
            <span class="material-icons">arrow_right_alt</span>
          </h2>
          <div class="mp4-wrap">
            <input type="radio" id="mp4" name="extension" value="mp4" v-model="extension" />
            <label for="mp4">Mp4</label>
          </div>
          <div class="ogg-wrap">
            <input type="radio" id="ogg" name="extension" value="ogg" v-model="extension" />
            <label for="ogg">Ogg</label>
          </div>
        </div>

        <div class="upload">
          <h2>{{$t('adminVideo.chooseFile')}}</h2>
          <label class="label-upload" for="file-upload">{{$t('button.browse')}}</label>
          <span class="file-name">{{file.name? file.name: $t('adminVideo.noFileSelected')}}</span>
          <input type="file" id="file-upload" @change="getFile" />
          <button @click="upload">{{$t('button.upload')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../api";
import AdminMixin from './adminMixin';
export default {
  mixins: [
    AdminMixin
  ],
  data() {
    return {
      data: [],
      extension: '',
      type: '',
      file: {},
      selectedLocation: {}
    };
  },
  mounted () {
    this.getInfo();
  },
  methods: {
    async getInfo () {
      this.startLoading();
        let apiObj = {
          api: api.getInfo,
          onError: () => this.stopLoading()
        }
        const data = await this.apiCall(apiObj);
        this.data = data.data;
      this.stopLoading();
    },
    getFile (e) {
      this.file = e.target.files[0];
    },
    upload () {
      if (
        this.type === '' ||
        this.extension === '' ||
        this.file.name === undefined||
        this.selectedLocation.loc_id === undefined
      ) {
        this.handleError(new Error("Please fill all the requirements"));
        return;
      }

      let arrayOfChunks = this.formatFileForUploadToMars();

      this.setupAndStartUpload(arrayOfChunks);
    },
    formatFileForUploadToMars () {
      let file = this.file;
      const fileChunks = [];
      if (file.size > 1024 * 1024) {
        const fileToChunk = file;
        const chunkSize = 1024 * 1024 * 1; // Size of chunk in MB (it shouldnt go over 20 MB so mars can accept it)
        for (let j = 0; j < Math.floor(fileToChunk.size / chunkSize) + 1; j++) {
          const chunklet = fileToChunk.slice(
            j * chunkSize,
            (j + 1) * chunkSize
          );
          if (chunklet.size > 0) {
            fileChunks.push(chunklet);
          }
        }
      } else {
        fileChunks.push(file);
      }
      return fileChunks;
    },
    async setupAndStartUpload (arr) {
      let generateFormDataForOneChunk = (chunk) => {
        let isFirst = arr[0] == chunk ? true : false;
        let isLast = arr[arr.length - 1] == chunk ? true : false;

        const formData = new FormData();

        formData.append("loc_id", this.selectedLocation.loc_id);
        formData.append("ltp_code", this.selectedLocation.ltp_code);
        formData.append("data", chunk);
        formData.append("type", this.type);
        formData.append("extension", this.extension);
        formData.append("isFirst", isFirst);
        formData.append("isLast", isLast);

        return formData;
      };
      this.startLoading();

      let preparedChunksForUpload = [];
      for (let i = 0; i < arr.length; i++) {
        const chunk = arr[i];
        let formData = generateFormDataForOneChunk(chunk);
        preparedChunksForUpload.push(formData);
      }
      let crashed;
      for (let i = 0; i < preparedChunksForUpload.length; i++) {
        const formDataOfOneChunk = preparedChunksForUpload[i];
        crashed = await this.uploadSingleChunk(formDataOfOneChunk);
        if (crashed) break;
      }
      if (!crashed) this.showSuccessMessage(this.$t("adminVideo.videoUploaded"));
      this.stopLoading();
    },
    async uploadSingleChunk (chunk) {
      try {
        await api.uploadFile(chunk);
      } catch (error) {
        this.handleError(error)
        return true;
      }
    },
  }
};
</script>

<style scoped>
hr {
  width: 90%;
  margin: 0;
  border-top: 1px solid var(--button-color-blue);
}
h1 {
  margin: 35px;
}
h2 {
  width: 100%;
  height: 20px;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  position: relative;
}
select,
.mp4-wrap label,
.ogg-wrap label,
.mp4-wrap input,
.ogg-wrap input,
.label-upload {
  cursor: pointer;
}
.video-wrap {
  background-color: #e5e5e5;
  display: flex;
  justify-content: center;
  align-items: center;
}
.form-wrap {
  width: 55%;
  margin-bottom: 20%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 0px 36px -11px rgba(0, 0, 0, 0.75);
  border-radius: 20px;
}
.upload-wrap {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 200px;
  align-items: center;
}
.video-for,
.extension,
.types,
.upload {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 25%;
  height: 100%;
}
.mp4-wrap,
.ogg-wrap {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 120px;
}
.mp4-wrap input[type="radio"],
.ogg-wrap input[type="radio"] {
  width: 15px;
  margin: 0;
  margin-right: 15px;
}
.mp4-wrap label,
.ogg-wrap label {
  width: 50%;
}
.upload button {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  white-space: nowrap;
  border: none;
  padding: 2% 4%;
  font-size: 1em;
  border-radius: 100px;
  font-size: 25px;
  font-weight: 600;
  background: var(--button-color-blue);
  color: white;
  margin-top: 8%;
}
.upload button:focus,
.upload button:active {
  border: none;
  outline: none;
}
.label-upload {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  white-space: nowrap;
  border: none;
  padding: 2% 4%;
  font-size: 1em;
  border-radius: 100px;
  font-size: 20px;
  font-weight: 600;
  background: #f68d22;
  color: white;
}
.file-name {
  text-align: center;
  font-size: 13px;
}
.material-icons {
  font-size: 40px;
  position: absolute;
  right: 0px;
}
input[type="file"] {
  display: none;
}
</style>